import React, {useEffect, useState} from "react";
import { navigate, Link } from 'gatsby'
import Helmet from 'react-helmet';


const NotFoundPage = () => {
	let redirect = () => navigate('/')
	let [count, counting] = useState(5)

	useEffect(() => {
		setTimeout(function() { 
			redirect() 
		}, 3000);
	}, []);

// 	useEffect(() => {
// 		let timer = setInterval(() => {
// 			let  counter  = count;
// 				counting(counter-1)
// 		}, 1000)

// // with return cleaning the interval before component will unmount
// 		return function clearinterval() {
// 			clearInterval(timer)
// 		};

// 	})


	return (
		<div className='transparentContainer flex900'>
			<Helmet
				title="Page Not Found - Barcelona Code School"
				meta={[
					{ property: "og:title", content: "Page Not Found - Barcelona Code School" },
					{ property: "og:url", content: "https://barcelonacodeschool.com/404/" },
					{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
					{ name: 'description', content: 'The page you are looking for does not exist. Please check the URL or return to the homepage.' },
					{ name: 'keywords', content: '404, not found, barcelona code school, bcs, coding school, bootcamp' }
				]}
			/>
		<h1>This page is not found.</h1>
		<h2>Sorry...</h2>
		<p><Link to="/">Go to the homepage instead?</Link></p>
		{/*<p>Taking you to the homepage instead...homepage in {count} {count == 1 ? 'second' : 'seconds'}</p>*/}
		</div>)
}

export default NotFoundPage;
